import * as React from "react";

import { IText_EventViews } from "../../classes/text";

export interface IParticipantProps {
  members: string[];
  nonMembers: string[];
  eventViewText: IText_EventViews;
}

export const ParticipantsDisplaySection = (props: IParticipantProps) => {

    return (
        <div className="CAL-EVENT-cR-content">
            <div className="CAL-EVENT-cR-c-stacked">
                <div>
                    <strong>{props.eventViewText.members} </strong>{props.members}                    
                </div>
                <div>
                    <strong>{props.eventViewText.nonMembers} </strong>{props.nonMembers}
                    <div></div>
                </div>
            </div>
        </div>
    );
};
